import { fitsKind } from '@/mbp/activityKind'

// Whether marking a task or activity Completed opens the result and notes dialog
// (ActivityMeetingDialog). It used to open only for Meetings and Calls, or from
// Overdue, so an Email or a Task was completed with no result. Now every type
// records one, from every open status. The type is not part of the rule.
export function opensResultDialog (newStatusName, currentStatusName) {
  return newStatusName === 'Completed' && ['Upcoming', 'Rescheduled', 'Overdue', 'Task'].includes(currentStatusName)
}

// The statuses the status menu offers from the current one. An undated task
// (status "Task") can only be Completed; a dated task of any type, like an
// activity, can be Cancelled or Rescheduled too. P8: only statuses that show on
// the record's kind ([kind], TASK or ACTIVITY) are offered.
export function nextStatusesFor (currentStatusName, statuses, kind) {
  const fitting = (statuses || []).filter(s => fitsKind(s, kind))
  const pick = wanted => wanted.map(n => fitting.find(s => s.statusName === n)).filter(Boolean)
  if (currentStatusName === 'Upcoming' || currentStatusName === 'Overdue') return pick(['Completed', 'Cancelled', 'Rescheduled'])
  if (currentStatusName === 'Rescheduled') return pick(['Completed', 'Cancelled'])
  if (currentStatusName === 'Task') return pick(['Completed'])
  return fitting
}
